import SalesFormPage from "@/pages/apprenticeship/enterprise/enterprise-site/sales-form";
import Protected from "@/pages/protected";
import { DataService } from "@/services/data";
import { handle_error } from "@/utils/wretch";
import { Outlet, RouteObject } from "react-router-dom";

const ApprenticeshipFormsRoute: RouteObject = {
    path: "alternance",
    element: (
        <Protected>
            <Outlet />
        </Protected>
    ),
    children: [
        {
            path: "offre-entreprise",
            loader: async () => {
                const from_sale_form = await DataService.client.url(`/apprenticeship/offers/from_sale_form/`).get().json();
                return from_sale_form;
            },
            action: async ({ request }) => {
                const data = await request.json();
                try {
                    const content = await DataService.client.url(`/apprenticeship/offers/from_sale_form/`).post(data).json();
                    return { success: true, content: content };
                } catch (error: any) {
                    return handle_error(error);
                }
            },
            element: <SalesFormPage />
        }
    ]
};
export default ApprenticeshipFormsRoute;
